<template>
    <div>
        <div>
            <el-form :inline="true" :model="formInline" class="demo-form-inline">
                <el-form-item label>
                    <el-input v-model="formInline.orderNo" placeholder="收货人/手机号" size="mini"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="success" size="mini" @click="handleSearch">查询</el-button>
                    <el-button type="success" @click="handleAdd" size="mini">新增地址</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div>
            <table v-if="address && address.list">
                <tr class="th">
                    <td v-if="isFromOrder"></td>
                    <td>课题组</td>
                    <td>收货人</td>
                    <td>手机号</td>
                    <td>收货地址</td>
                    <td v-if="!isFromOrder">操作</td>
                </tr>
                <tbody>
                    <tr v-for="(item, index) in address.list" :key="index">
                        <td v-if="isFromOrder" class="radio">
                            <el-radio v-model="currentAddress" :label="item.id"></el-radio>
                        </td>
                        <td>{{item.topicName}}</td>
                        <td>{{item.contact}}</td>
                        <td>{{item.contactPhone}}</td>
                        <td>{{item.province}}{{item.city}}{{item.area}}{{item.address}}</td>
                        <td v-if="!isFromOrder">
                            <el-button type="success" size="mini" @click="handleUpdate(item)">修改</el-button>
                            <el-button type="danger" size="mini" @click="handleDelete(item)">删除</el-button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div
                class="table-empty"
                v-if="!address || !address.list || (address.list && address.list.length === 0)"
            >
                <i class="el-icon-document-copy"></i>
                <p>暂无数据</p>
            </div>
        </div>
        <div class="pagination">
            <el-pagination
                v-if="address"
                background
                layout="prev, pager, next,total"
                :total="address.count"
                :page-size="address.pageSize"
                :current-page="address.page"
                @current-change="handleCurrentChange"
            ></el-pagination>
        </div>
        <el-dialog
            title="收货地址"
            :visible.sync="dialogFormVisible"
            width="500px"
            :append-to-body="isFromOrder"
        >
            <el-form ref="form" :model="form" label-width="110px" :rules="rules">
                <el-form-item label="课件组" prop="topicName">
                    <el-input v-model="form.topicName"></el-input>
                </el-form-item>                
                <el-form-item label="收货人" prop="contact">
                    <el-input v-model="form.contact"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="contactPhone">
                    <el-input v-model="form.contactPhone"></el-input>
                </el-form-item>
                <el-form-item label="省市区" prop="pca">
                    <el-cascader
                        style="width: 100%;"
                        :options="areaAddress"
                        :props="props"
                        v-model="form.pca"
                    ></el-cascader>
                </el-form-item>
                <el-form-item label="详细地址" prop="address">
                    <el-input v-model="form.address"></el-input>
                </el-form-item>
                <el-form-item label="设为默认地址" prop="defaultAddress">
                    <el-switch :active-value="1" :inactive-value="0" v-model="form.defaultAddress"></el-switch>
                </el-form-item>
                <el-form-item label="同步到收票地址" prop="isInvoiceAddress">
                    <el-switch
                        :active-value="1"
                        :inactive-value="0"
                        v-model="form.isInvoiceAddress"
                    ></el-switch>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit('form')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import * as apis from '../../fetch/user';
import { address } from '../../fetch/address';

export default {
    name: 'Address',
    props: ['from'],
    data() {
        return {
            currentAddress: null,
            formInline: {
                orderNo: '',
            },
            dialogFormVisible: false,
            form: {
                contact: '',
                address: '',
                contactPhone: '',
                pca: '',
                defaultAddress: false,
                isInvoiceAddress: false,
                topicName: '',
            },
            rules: {
                contact: [{ required: true, message: '请输入收货人', trigger: 'blur' }],
                address: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
                contactPhone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
                pca: [{ required: true, message: '请选择省市区', trigger: 'blur' }],
            },
            formLabelWidth: '120px',
            address: null,
            props: {
                value: 'label',
                children: 'children',
            },
        };
    },
    computed: {
        isFromOrder() {
            return this.from === 'order';
        },
        areaAddress() {
            return address;
        },
    },
    methods: {
        getAddress(orderNo = '', page = 1) {
            apis.getAddress(orderNo, page).then(res => {
                this.address = res;
            });
        },
        handleSearch() {
            this.getAddress(this.formInline.orderNo, 1);
        },
        handleCurrentChange(page) {
            this.getAddress(this.formInline.orderNo, page);
        },
        handleSubmit(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    const params = {
                        ...this.form,
                        province: this.form.pca[0],
                        city: this.form.pca[1],
                        area: this.form.pca[2],
                    };
                    if (params.id) {
                        apis.updateAddress(params).then(res => {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                            });
                            this.dialogFormVisible = false;
                            this.getAddress();
                        });
                    } else {
                        apis.addAddress(params).then(res => {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                            });
                            this.dialogFormVisible = false;
                            this.getAddress();
                        });
                    }
                }
            });
        },
        handleAdd() {
            this.form = {};
            this.dialogFormVisible = true;
        },
        handleUpdate(item) {
            this.form = { ...item, pca: [item.province, item.city, item.area] };
            this.dialogFormVisible = true;
        },
        handleDelete(item) {
            apis.deleteAddress(item.id).then(res => {
                this.$message({
                    message: '操作成功',
                    type: 'success',
                });
                this.getAddress();
            });
        },
    },
    mounted() {
        this.getAddress();
    },
};
</script>


<style scoped lang="less">
.radio label {
    width: 20px;
    height: 100%;
    overflow: hidden;
}
</style>